// extracted by mini-css-extract-plugin
module.exports = {"button":"jira-issue-collector-block-module--button--y3m1U"};